
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_8nwvw_10",
  "with-toolbar": "awsui_with-toolbar_l0dv0_8nwvw_44",
  "header": "awsui_header_l0dv0_8nwvw_48",
  "list--with-icons": "awsui_list--with-icons_l0dv0_8nwvw_61",
  "header-link": "awsui_header-link_l0dv0_8nwvw_65",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_8nwvw_76",
  "header-link-text": "awsui_header-link-text_l0dv0_8nwvw_76",
  "header-logo": "awsui_header-logo_l0dv0_8nwvw_81",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_8nwvw_87",
  "items-control": "awsui_items-control_l0dv0_8nwvw_92",
  "list-container": "awsui_list-container_l0dv0_8nwvw_97",
  "divider-header": "awsui_divider-header_l0dv0_8nwvw_105",
  "root--collapsed": "awsui_root--collapsed_l0dv0_8nwvw_109",
  "list": "awsui_list_l0dv0_8nwvw_61",
  "list-variant-root": "awsui_list-variant-root_l0dv0_8nwvw_122",
  "list-variant-root--first": "awsui_list-variant-root--first_l0dv0_8nwvw_129",
  "list-variant-root--collapsed": "awsui_list-variant-root--collapsed_l0dv0_8nwvw_132",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_8nwvw_139",
  "list-variant-expandable-link-group--collapsed": "awsui_list-variant-expandable-link-group--collapsed_l0dv0_8nwvw_145",
  "list-variant-section": "awsui_list-variant-section_l0dv0_8nwvw_149",
  "list-variant-section--collapsed": "awsui_list-variant-section--collapsed_l0dv0_8nwvw_152",
  "list-variant-link-group": "awsui_list-variant-link-group_l0dv0_8nwvw_161",
  "list-variant-link-group--collapsed": "awsui_list-variant-link-group--collapsed_l0dv0_8nwvw_164",
  "link-group-children": "awsui_link-group-children_l0dv0_8nwvw_168",
  "link-group-children--collapsed": "awsui_link-group-children--collapsed_l0dv0_8nwvw_172",
  "link-group-children-inner": "awsui_link-group-children-inner_l0dv0_8nwvw_176",
  "link-group-children-inner--expanded": "awsui_link-group-children-inner--expanded_l0dv0_8nwvw_182",
  "link-group-children-inner--settled": "awsui_link-group-children-inner--settled_l0dv0_8nwvw_185",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_8nwvw_189",
  "list-variant-section-group--collapsed": "awsui_list-variant-section-group--collapsed_l0dv0_8nwvw_195",
  "list-item": "awsui_list-item_l0dv0_8nwvw_199",
  "list-item--collapsed": "awsui_list-item--collapsed_l0dv0_8nwvw_212",
  "list-item--link-with-info": "awsui_list-item--link-with-info_l0dv0_8nwvw_218",
  "list-item--group": "awsui_list-item--group_l0dv0_8nwvw_223",
  "section": "awsui_section_l0dv0_8nwvw_223",
  "section-group": "awsui_section-group_l0dv0_8nwvw_224",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_8nwvw_229",
  "section--no-ident": "awsui_section--no-ident_l0dv0_8nwvw_232",
  "section--expand-icon-end": "awsui_section--expand-icon-end_l0dv0_8nwvw_232",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_8nwvw_233",
  "expandable-link-group--expand-icon-end": "awsui_expandable-link-group--expand-icon-end_l0dv0_8nwvw_234",
  "section--collapsed": "awsui_section--collapsed_l0dv0_8nwvw_237",
  "expandable-link-group--collapsed": "awsui_expandable-link-group--collapsed_l0dv0_8nwvw_238",
  "expandable-link-group--active": "awsui_expandable-link-group--active_l0dv0_8nwvw_262",
  "item-icon": "awsui_item-icon_l0dv0_8nwvw_266",
  "refresh": "awsui_refresh_l0dv0_8nwvw_283",
  "section-header": "awsui_section-header_l0dv0_8nwvw_304",
  "section-group-title": "awsui_section-group-title_l0dv0_8nwvw_319",
  "section-group-title--collapsed": "awsui_section-group-title--collapsed_l0dv0_8nwvw_327",
  "link": "awsui_link_l0dv0_8nwvw_168",
  "link-active": "awsui_link-active_l0dv0_8nwvw_359",
  "link--collapsed": "awsui_link--collapsed_l0dv0_8nwvw_366",
  "header-link-active": "awsui_header-link-active_l0dv0_8nwvw_434",
  "link-text-wrapper-content": "awsui_link-text-wrapper-content_l0dv0_8nwvw_463",
  "link-text-wrapper": "awsui_link-text-wrapper_l0dv0_8nwvw_463",
  "link-text-wrapper--collapsed": "awsui_link-text-wrapper--collapsed_l0dv0_8nwvw_477",
  "label-text": "awsui_label-text_l0dv0_8nwvw_482",
  "label-text--collapsed": "awsui_label-text--collapsed_l0dv0_8nwvw_489",
  "info": "awsui_info_l0dv0_8nwvw_495",
  "item-icon--collapsed": "awsui_item-icon--collapsed_l0dv0_8nwvw_504",
  "external-icon": "awsui_external-icon_l0dv0_8nwvw_508",
  "divider": "awsui_divider_l0dv0_8nwvw_105",
  "divider-default": "awsui_divider-default_l0dv0_8nwvw_516",
  "divider--collapsed": "awsui_divider--collapsed_l0dv0_8nwvw_520"
};
  